import React,{useState} from 'react'
import { Button,Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const Detail = ({data}) => {
        const [show, setShow] = useState(false);  
        const handleClose = () => setShow(false);
        const handleShow = () => setShow(true);
      
        return (
          <>
            <p className="mt-2 text-white" id="detail"
            variant="light" onClick={handleShow}>
              {data.name} 
            </p>
      
            <Modal
              show={show}
              onHide={handleClose}
              backdrop="static"
              keyboard={false}
            >
              <Modal.Header closeButton>
                <Modal.Title>{data.name} </Modal.Title>
              </Modal.Header>
              <Modal.Body className="d-flex">
                <img src={data.image.default}  style={gambar} alt ={data.name}/>
                <p className="pl-3">{data.describe}</p>
              </Modal.Body>
              <Modal.Footer>
                <Button primary="true" onClick={handleClose}>
                  Close
                </Button>

              </Modal.Footer>
            </Modal>
          </>
        );
}

export default Detail

const gambar = {
  width :"100%",
  height:"100%"
}